import { render, staticRenderFns } from "./ImageViewerModal.vue?vue&type=template&id=05e6fc7b&scoped=true"
import script from "./ImageViewerModal.vue?vue&type=script&lang=js"
export * from "./ImageViewerModal.vue?vue&type=script&lang=js"
import style0 from "./ImageViewerModal.vue?vue&type=style&index=0&id=05e6fc7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e6fc7b",
  null
  
)

export default component.exports